let promoInitialized = false;
let promoLocked = false;

async function fetchCart() {
  const res = await fetch("/cart.js");
  return res.json();
}

function countIncenseBoxes(cart) {
  return cart.items.reduce((total, item) => {
    const title = (item.product_title || "").toLowerCase();
    return title.includes("incense") ? total + item.quantity : total;
  }, 0);
}

function hasHolder(cart) {
  return cart.items.some(item =>
    item.properties && item.properties["FreeHolderPromo"] === "true"
  );
}

function getHolderLineKey(cart) {
  const item = cart.items.find(i =>
    i.properties && i.properties["FreeHolderPromo"] === "true"
  );
  return item?.key || null;
}

async function removeHolder() {
  const cart = await fetchCart();
  const key = getHolderLineKey(cart);
  if (key) {
    await fetch("/cart/change.js", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ id: key, quantity: 0 }),
    });
  }
}

async function addHolder(variantId) {
  await fetch("/cart/add.js", {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({
      id: variantId,
      quantity: 1,
      properties: { _FreeHolderPromo: "true" },
    }),
  });
}

async function updatePromoUI() {
  if (promoLocked) return;
  promoLocked = true;

  try {
    const promoContainer = document.getElementById("free-holder-promo");
    const select = document.getElementById("free-holder-select");
    const message = document.getElementById("free-holder-message");

    if (!promoContainer || !select || !message) {
      promoLocked = false;
      return;
    }

    const cart = await fetchCart();
    const incenseCount = countIncenseBoxes(cart);
    const holderInCart = hasHolder(cart);

    if (incenseCount >= 4 && !holderInCart) {
  promoContainer.classList.remove("hidden");
  message.textContent = "🎁 You've earned a free Château holder! Choose one below:";
} else {
  // Always show, but update message
  promoContainer.classList.remove("hidden");
  message.textContent = `Buy any 4 incense boxes to unlock your free Château holder 🎁 (${incenseCount} of 4 selected)`;

  if (incenseCount < 4 && holderInCart) {
    await removeHolder();
  }
}

    // Prevent multiple listeners
    if (!select.dataset.listenerAttached) {
      select.addEventListener("change", async function () {
  const variantId = this.value;
  if (!variantId) return;

  await addHolder(variantId);
  promoContainer.classList.add("hidden");

  // ✅ Force the cart drawer and page state to update
  window.location.reload();
});
      select.dataset.listenerAttached = "true";
    }
  } catch (err) {
    console.error("Promo script error:", err);
  } finally {
    promoLocked = false;
  }
}

function initPromoWatcher() {
  const checkPromo = () => {
    const promoSelect = document.getElementById("free-holder-select");
    if (promoSelect && !promoInitialized) {
      promoInitialized = true;
      updatePromoUI();
    }
  };

  // Detect DOM changes (cart drawer opening or Alpine loading)
  const observer = new MutationObserver(checkPromo);
  observer.observe(document.body, { childList: true, subtree: true });

  // Keep watching regularly
  setInterval(updatePromoUI, 3000);

  // Hook into Shopify cart events
  document.addEventListener("cart:updated", () => {
    setTimeout(updatePromoUI, 500); // add delay to avoid race condition
  });

  // First load
  updatePromoUI();
}

// Run on full load
document.addEventListener("DOMContentLoaded", initPromoWatcher);
